import styled from 'styled-components';
import { Container } from 'styles';

export const Wrapper = styled(Container).attrs({
  flex: true,
  alignItems: 'center',
})`
  border-radius: 8px;
  border: ${props =>
    `1px solid ${props.theme.colors.background.warningBright}`};
  background: ${props => props.theme.colors.background.warning};
  padding: 16px;
`;
